import { FC, SyntheticEvent, useCallback, useState } from "react";
import { SportTypes } from "@finbackoffice/fe-core";
import { TranslationScopes } from "@finbackoffice/enums";
import { useRuntimeConfig } from "@finbackoffice/site-core";
import { Svg } from "components/base/svg/Svg";
import Img from "components/base/img/Img";
import Translate from "components/base/translate/Translate";
import SportIcon from "components/base/sport-icon/SportIcon";
import styles from "../policies.module.sass";
import PoliciesCommonContent from "../PoliciesCommonContent";

const BetTypesAndRules: FC = () => {
    return (
        <>
            <div className={styles.subHeader} id="bet_types" style={{ marginTop: 20 }}>
                <Svg
                    src="/common/desktop/base-icons/policies-bet-types.svg"
                    wrapper="span"
                    className="svg-sport-icon"
                    loader
                />
                <h2>
                    <Translate
                        tid="policies_sportsbook_betTypes"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </h2>
            </div>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_types_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_types_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_rules_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const SettlementAndCancellation: FC = () => {
    return (
        <>
            <div className={styles.subHeader} id="settlement_cancellation">
                <Svg
                    src="/common/desktop/base-icons/policies-settlement-cancellation.svg"
                    wrapper="span"
                    className="svg-sport-icon"
                    loader
                />
                <h2>
                    <Translate
                        tid="policies_sportsbook_settlement"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </h2>
            </div>
            <Translate
                tid="policies_sportsbook_settlement_mainInfo"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <h3>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_thirdParty_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </h3>
            <p>
                <Translate
                    tid="policies_sportsbook_settlement_thirdParty_info"
                    namespace={TranslationScopes.PoliciesSportsbook}
                />
            </p>

            <h3 style={{ marginTop: 12 }}>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_outrightMarkets_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </h3>
            <p>
                <Translate
                    tid="policies_sportsbook_settlement_outrightMarkets_paragraph1"
                    namespace={TranslationScopes.PoliciesSportsbook}
                />
            </p>
            <p>
                <Translate
                    tid="policies_sportsbook_settlement_outrightMarkets_paragraph2"
                    namespace={TranslationScopes.PoliciesSportsbook}
                />
            </p>
            <p>
                <Translate
                    tid="policies_sportsbook_settlement_outrightMarkets_paragraph3"
                    namespace={TranslationScopes.PoliciesSportsbook}
                />
            </p>
        </>
    );
};

const Soccer: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");
    return (
        <>
            <div className={styles.subHeader} style={{ marginTop: 20 }} id={`${SportTypes.SOCCER}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.SOCCER}.webp`}
                        alt="Soccer"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.SOCCER} />
                <h2>
                    <Translate tid="sport_soccer" />
                </h2>
            </div>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_soccer_settlement_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_soccer_bookingMarkets_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_soccer_bookingMarkets_info1"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <Translate
                    tid="policies_sportsbook_soccer_bookingMarkets_paragraph1"
                    namespace={TranslationScopes.PoliciesSportsbook}
                />
            </p>
            <Translate
                tid="policies_sportsbook_soccer_bookingMarkets_info2"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
            <p>
                <Translate
                    tid="policies_sportsbook_soccer_bookingMarkets_paragraph2"
                    namespace={TranslationScopes.PoliciesSportsbook}
                />
            </p>
            <Translate
                tid="policies_sportsbook_soccer_bookingMarkets_info3"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_soccer_cornerMarkets_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <ul>
                <li>
                    <Translate
                        tid="policies_sportsbook_soccer_cornerMarkets_info"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </li>
            </ul>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_soccer_nextGoalscorer_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_soccer_nextGoalscorer_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_soccer_anytimeGoalscorer_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_soccer_anytimeGoalscorer_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_soccer_intervalMarkets_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_soccer_intervalMarkets_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_soccer_nextScoring_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_soccer_nextScoring_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Tennis: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.TENNIS}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.TENNIS}.webp`}
                        alt="Tennis"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.TENNIS} />
                <h2>
                    <Translate tid="sport_tennis" />
                </h2>
            </div>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_tennis_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Basketball: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.BASKETBALL}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.BASKETBALL}.webp`}
                        alt="Basketball"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.BASKETBALL} />
                <h2>
                    <Translate tid="sport_basketball" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_basketball_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const AmericanFootball: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.AMERICAN_FOOTBALL}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.AMERICAN_FOOTBALL}.webp`}
                        alt="American Football"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.AMERICAN_FOOTBALL} />
                <h2>
                    <Translate tid="sport_american_football" />
                </h2>
            </div>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_american_football_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_american_football_player_props_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_american_football_player_props_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const IceHockey: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.ICE_HOCKEY}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.ICE_HOCKEY}.webp`}
                        alt="Ice Hockey"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.ICE_HOCKEY} />
                <h2>
                    <Translate tid="sport_ice_hockey" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_ice_hockey_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_ice_hockey_heading_two"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_ice_hockey_heading_two_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_ice_hockey_next_scoring_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_ice_hockey_next_scoring_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_ice_hockey_player_props_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_ice_hockey_player_props_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Baseball: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.BASEBALL}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.BASEBALL}.webp`}
                        alt="Baseball"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.BASEBALL} />
                <h2>
                    <Translate tid="sport_baseball" />
                </h2>
            </div>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_baseball_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_baseball_rapid_markets_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_baseball_rapid_markets_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_baseball_player_props_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_baseball_player_props_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Handball: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.HANDBALL}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.HANDBALL}.webp`}
                        alt="Handball"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.HANDBALL} />
                <h2>
                    <Translate tid="sport_handball" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_handball_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Volleyball: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.VOLLEYBALL}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.VOLLEYBALL}.webp`}
                        alt="Volleyball"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.VOLLEYBALL} />
                <h2>
                    <Translate tid="sport_volleyball" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_volleyball_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Futsal: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.FUTSAL}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.FUTSAL}.webp`}
                        alt="Futsal"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.FUTSAL} />
                <h2>
                    <Translate tid="sport_futsal" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_futsal_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Badminton: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");
    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.BADMINTON}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.BADMINTON}.webp`}
                        alt="Badminton"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.BADMINTON} />
                <h2>
                    <Translate tid="sport_badminton" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_badminton_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Rugby: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.RUGBY}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.RUGBY}.webp`}
                        alt="Rugby"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.RUGBY} />
                <h2>
                    <Translate tid="sport_rugby" />
                </h2>
            </div>
            <h3>
                <b>
                    <Translate
                        tid="policies_sportsbook_rugby_union_league"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </h3>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_rugby_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
            <h3>
                <b>
                    <Translate
                        tid="policies_sportsbook_rugby_sevens"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </h3>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_rugby_sevens_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Darts: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");
    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.DARTS}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.DARTS}.webp`}
                        alt="Darts"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.DARTS} />
                <h2>
                    <Translate tid="sport_darts" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_darts_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Snooker: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");
    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.SNOOKER}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.SNOOKER}.webp`}
                        alt="Snooker"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.SNOOKER} />
                <h2>
                    <Translate tid="sport_snooker" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_snooker_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const TableTennis: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.TABLE_TENNIS}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.TABLE_TENNIS}.webp`}
                        alt="Table tennis"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.TABLE_TENNIS} />
                <h2>
                    <Translate tid="sport_table_tennis" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_table_tennis_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Bowls: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.BOWLS}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.BOWLS}.webp`}
                        alt="Bowls"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.BOWLS} />
                <h2>
                    <Translate tid="sport_bowls" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_bowls_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Squash: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={`${SportTypes.SQUASH}`}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.SQUASH}.webp`}
                        alt="Squash"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.SQUASH} />
                <h2>
                    <Translate tid="sport_squash" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_squash_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const AussieRules: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={SportTypes.AUSSIE_RULES.toString()}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.AUSSIE_RULES}.webp`}
                        alt="Aussie Rules"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.AUSSIE_RULES} />
                <h2>
                    <Translate tid="sport_aussie_rules" />
                </h2>
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_aussie_rules_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const FieldHockey: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={SportTypes.FIELD_HOCKEY.toString()}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.FIELD_HOCKEY}.webp`}
                        alt="Field Hockey"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.FIELD_HOCKEY} />
                <Translate tid="sport_field_hockey" />
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_settlement_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>

            <Translate
                tid="policies_sportsbook_field_hockey_rules_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <h3>
                <b>
                    <Translate
                        tid="policies_sportsbook_field_hockey_heading1"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </h3>

            <p>
                <Translate
                    tid="policies_sportsbook_field_hockey_info1"
                    namespace={TranslationScopes.PoliciesSportsbook}
                />
            </p>
            <h3 style={{ marginTop: 12 }}>
                <b>
                    <Translate
                        tid="policies_sportsbook_field_hockey_heading2"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </h3>
            <Translate
                tid="policies_sportsbook_field_hockey_info2"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
            <h3>
                <b>
                    <Translate
                        tid="policies_sportsbook_field_hockey_heading3"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </h3>
            <p>
                <Translate
                    tid="policies_sportsbook_field_hockey_heading3_p1"
                    namespace={TranslationScopes.PoliciesSportsbook}
                />
            </p>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_field_hockey_heading3_p2"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_field_hockey_info3"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_field_hockey_heading4"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_field_hockey_info4"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Boxing: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={SportTypes.BOXING.toString()}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.BOXING}.webp`}
                        alt="Boxing"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.BOXING} />
                <Translate tid="sport_boxing" />
            </div>

            <p>
                <Translate
                    tid="policies_sportsbook_boxing_p"
                    namespace={TranslationScopes.PoliciesSportsbook}
                />
            </p>

            <h3 style={{ marginTop: 12 }}>
                <b>
                    <Translate
                        tid="policies_sportsbook_boxing_heading"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </h3>

            <Translate
                tid="policies_sportsbook_boxing_info"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const Formula1: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    return (
        <>
            <div className={styles.subHeader} id={SportTypes.FORMULA1.toString()}>
                <span className={styles.headerBg}>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/sport-headers/${SportTypes.FORMULA1}.webp`}
                        alt="Formula"
                        width={136}
                        height={30}
                    />
                </span>
                <SportIcon sportId={SportTypes.FORMULA1} />
                <Translate tid="sport_formula1" />
            </div>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_formula1_heading1"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_formula1_info1"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_formula1_heading2"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_formula1_info2"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_formula1_heading3"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_formula1_info3"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_formula1_heading4"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_formula1_info4"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_formula1_heading5"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_formula1_info5"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_formula1_heading6"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_formula1_info6"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>

            <p>
                <b>
                    <Translate
                        tid="policies_sportsbook_formula1_heading7"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </b>
            </p>
            <Translate
                tid="policies_sportsbook_formula1_info7"
                dangerous
                namespace={TranslationScopes.PoliciesSportsbook}>
                <ul />
            </Translate>
        </>
    );
};

const PoliciesSportsbook: FC = () => {
    const [scrollToPos, setScrollToPos] = useState<number | null>(null);

    const handleClick = (e: SyntheticEvent<HTMLElement>) => {
        const elementId = (e.target as HTMLElement).getAttribute("data-heading")?.toString();
        if (elementId) {
            const element = document.getElementById(elementId);
            if (element) {
                setScrollToPos(element.offsetTop);
            }
        }
    };

    const handleClearScrollToPos = useCallback(() => setScrollToPos(null), []);

    return (
        <PoliciesCommonContent
            translationKey="sportsbook"
            translationScope={TranslationScopes.PoliciesSportsbook}
            headingIcon={{ width: 20, height: 20 }}
            scrollTo={scrollToPos}
            clearScrollToPos={handleClearScrollToPos}>
            <nav className={styles.sports}>
                <a onClick={handleClick} data-heading="bet_types">
                    <Svg
                        src="/common/desktop/base-icons/policies-bet-types.svg"
                        wrapper="span"
                        className="svg-sport-icon"
                        loader
                    />
                    <Translate
                        tid="policies_sportsbook_betTypes"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </a>
                <a onClick={handleClick} data-heading="settlement_cancellation">
                    <Svg
                        src="/common/desktop/base-icons/policies-settlement-cancellation.svg"
                        wrapper="span"
                        className="svg-sport-icon"
                        loader
                    />
                    <Translate
                        tid="policies_sportsbook_settlement"
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.SOCCER}>
                    <SportIcon sportId={SportTypes.SOCCER} />
                    <Translate tid="sport_soccer" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.TENNIS}>
                    <SportIcon sportId={SportTypes.TENNIS} />
                    <Translate tid="sport_tennis" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.BASKETBALL}>
                    <SportIcon sportId={SportTypes.BASKETBALL} />
                    <Translate tid="sport_basketball" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.AMERICAN_FOOTBALL}>
                    <SportIcon sportId={SportTypes.AMERICAN_FOOTBALL} />
                    <Translate tid="sport_american_football" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.ICE_HOCKEY}>
                    <SportIcon sportId={SportTypes.ICE_HOCKEY} />
                    <Translate tid="sport_ice_hockey" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.BASEBALL}>
                    <SportIcon sportId={SportTypes.BASEBALL} />
                    <Translate tid="sport_baseball" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.HANDBALL}>
                    <SportIcon sportId={SportTypes.HANDBALL} />
                    <Translate tid="sport_handball" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.VOLLEYBALL}>
                    <SportIcon sportId={SportTypes.VOLLEYBALL} />
                    <Translate tid="sport_volleyball" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.FUTSAL}>
                    <SportIcon sportId={SportTypes.FUTSAL} />
                    <Translate tid="sport_futsal" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.BADMINTON}>
                    <SportIcon sportId={SportTypes.BADMINTON} />
                    <Translate tid="sport_badminton" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.RUGBY}>
                    <SportIcon sportId={SportTypes.RUGBY} />
                    <Translate tid="sport_rugby" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.DARTS}>
                    <SportIcon sportId={SportTypes.DARTS} />
                    <Translate tid="sport_darts" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.SNOOKER}>
                    <SportIcon sportId={SportTypes.SNOOKER} />
                    <Translate tid="sport_snooker" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.TABLE_TENNIS}>
                    <SportIcon sportId={SportTypes.TABLE_TENNIS} />
                    <Translate tid="sport_table_tennis" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.BOWLS}>
                    <SportIcon sportId={SportTypes.BOWLS} />
                    <Translate tid="sport_bowls" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.SQUASH}>
                    <SportIcon sportId={SportTypes.SQUASH} />
                    <Translate tid="sport_squash" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.AUSSIE_RULES}>
                    <SportIcon sportId={SportTypes.AUSSIE_RULES} />
                    <Translate tid="sport_aussie_rules" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.FIELD_HOCKEY}>
                    <SportIcon sportId={SportTypes.FIELD_HOCKEY} />
                    <Translate tid="sport_field_hockey" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.BOXING}>
                    <SportIcon sportId={SportTypes.BOXING} />
                    <Translate tid="sport_boxing" />
                </a>
                <a onClick={handleClick} data-heading={SportTypes.FORMULA1}>
                    <SportIcon sportId={SportTypes.FORMULA1} />
                    <Translate tid="sport_formula1" />
                </a>
            </nav>

            <div className={styles.policiesSportsbookContent}>
                <BetTypesAndRules />
                <SettlementAndCancellation />
                <Soccer />
                <Tennis />
                <Basketball />
                <AmericanFootball />
                <IceHockey />
                <Baseball />
                <Handball />
                <Volleyball />
                <Futsal />
                <Badminton />
                <Rugby />
                <Darts />
                <Snooker />
                <TableTennis />
                <Bowls />
                <Squash />
                <AussieRules />
                <FieldHockey />
                <Boxing />
                <Formula1 />
            </div>
        </PoliciesCommonContent>
    );
};

export default PoliciesSportsbook;
